"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReasonMachine = void 0;
const xstate_1 = require("xstate");
const constants_1 = require("../../../lib/constants");
const States_1 = require("../../../lib/constants/States");
const actions_reasonMachine_1 = __importStar(require("./actions.reasonMachine"));
const guards_reasonMachine_1 = __importStar(require("./guards.reasonMachine"));
const services_reasonMachine_1 = __importStar(require("./services.reasonMachine"));
/**
 * Function to create ReasonMachine
 *
 * @param initialContext {ReasonMachineContext} - Initial context for ReasonMachine
 * @returns
 */
const createReasonMachine = (initialContext) => {
    return (0, xstate_1.createMachine)({
        id: 'reasonMachine',
        context: initialContext,
        initial: States_1.routing,
        on: {
            // Event for updating reschedule reason
            [constants_1.events.UPDATE_REASON]: {
                actions: [actions_reasonMachine_1.selectRescheduleReason],
                target: States_1.idle
            },
            // Event for rescheduling appointment
            [constants_1.events.RESCHEDULE_APPOINTMENT]: {
                target: States_1.appointmentRescheduling
            },
            // Event for keeping original appointment
            [constants_1.events.KEEP_ORIGINAL_APPOINTMENT]: {
                target: States_1.appointmentRescheduleSuccess,
                actions: [actions_reasonMachine_1.sendParentExit]
            },
            [constants_1.events.GO_BACK]: {
                actions: actions_reasonMachine_1.sendParentBack,
                target: States_1.exit
            }
        },
        states: {
            [States_1.routing]: {
                always: [
                    // bypass this step if reschedule reason data is already present
                    {
                        cond: guards_reasonMachine_1.isReasonDefined,
                        target: States_1.idle
                    },
                    {
                        target: States_1.fetchingReasons
                    }
                ]
            },
            [States_1.fetchingReasons]: {
                invoke: {
                    id: 'fetchingReasons',
                    src: services_reasonMachine_1.getRescheduleReasons,
                    onDone: {
                        actions: [actions_reasonMachine_1.setRescheduleReasons],
                        target: States_1.idle
                    },
                    onError: {
                        // no error logging is required as this is an optional field
                        target: States_1.idle
                    }
                }
            },
            [States_1.idle]: {},
            [States_1.appointmentRescheduling]: {
                invoke: {
                    id: 'rescheduleAppointment',
                    src: services_reasonMachine_1.rescheduleAppointment,
                    onDone: [
                        {
                            cond: guards_reasonMachine_1.isReschedulingSuccess,
                            target: States_1.appointmentReschedulingPending,
                            actions: actions_reasonMachine_1.updateAppointment
                        },
                        {
                            target: States_1.appointmentReschedulingFailed
                        }
                    ],
                    onError: {
                        target: States_1.appointmentReschedulingFailed
                    }
                }
            },
            // Fix for race condition when state does not transition to success before
            // sending data to the parent machine
            [States_1.appointmentReschedulingPending]: {
                after: {
                    RACE_CONDITION_DELAY: States_1.appointmentRescheduleSuccess
                }
            },
            [States_1.appointmentRescheduleSuccess]: {
                entry: [actions_reasonMachine_1.sendParentSuccess],
                type: 'final'
            },
            [States_1.appointmentReschedulingFailed]: {},
            [States_1.exit]: {
                type: 'final'
            }
        }
    }, {
        services: services_reasonMachine_1.default,
        actions: actions_reasonMachine_1.default,
        guards: guards_reasonMachine_1.default,
        delays: {
            RACE_CONDITION_DELAY: 0
        }
    });
};
exports.createReasonMachine = createReasonMachine;
//# sourceMappingURL=reasonMachine.js.map